import { ApiModule } from "@/api/api-module"

const apiPrefix = process.env.API_PREFIX_ACCOUNT || '/account/v1'

export class ApiAuth extends ApiModule {
  
  signIn(data){
    return new Promise((resolve, reject) => {
      this.http.post(`${apiPrefix}/SignIn`, data).then(
        response => {
          // resolve(response.data) 
          resolve(response)
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  signUp(data){
    return new Promise((resolve, reject) => {
      this.http.post(`${apiPrefix}/SignUp`, data).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  resendCode(data){
    return new Promise((resolve, reject) => {
      this.http.post(`${apiPrefix}/ResendCode`, data).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  confirm(data){
    return new Promise((resolve, reject) => {
      this.http.post(`${apiPrefix}/Confirm`, data).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  profile() {
    return new Promise((resolve, reject) => {
      this.http.get(`${apiPrefix}/MyProfile`, { withCredentials: true }).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  resetPassword(data){
    return new Promise((resolve, reject) => {
      this.http.post(`${apiPrefix}/ResetPass`, data).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  confirmPassword(data){
    return new Promise((resolve, reject) => {
      this.http.post(`${apiPrefix}/ResetPassConfirm`, data).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
 
}

let apiAuth = new ApiAuth("auth")

export default apiAuth



// WEBPACK FOOTER //
// ./src/apps/auth/api/index.js